import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import DirectorForm from './DirectorForm'
import DirectorCard from './DirectorCard'


import Resource from '../../stores/resource'
const DirectorStore = Resource('directors')

class NewDirector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      director: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    // Adjust attributes
    attributes.phones = {
      office: attributes.officePhone,
      mobile: attributes.mobilePhone
    }

    // Remove display-only fields
    delete attributes.mobilePhone
    delete attributes.officePhone
    // Build new full name
    const newFullName = `${attributes.firstName} ${attributes.lastName}`
    // Create!
    DirectorStore.create(attributes)
    .then((result) => {
      // We need to do another query to get included objects
      const director = result.data.data
      DirectorStore.findBy({id: director.id})
      .then((savedDirector) => {
        this.setState({
          saved: true,
          error: '',
          savedDirector: savedDirector.data,
          snackbarMessage: `Director "${newFullName}" created!`
        },
        () => {
          if (this.props.savedCallback) {
            this.props.savedCallback(this.state.savedDirector)
          }
        })
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/directors`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const director = this.state.director
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <DirectorForm
          formTitle={this.props.formTitle}
          firstName={director.firstName}
          lastName={director.lastName}
          title={director.title}
          email={director.email}
          address={director.address}
          city={director.city}
          province={director.province}
          postalCode={director.postalCode}
          country={director.country}
          phones={director.phones}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create director">
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(this.state.saved)}
            title="Director created">
            <p>
              A new director has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <DirectorCard
              director={this.state.savedDirector}
              editCallback={() => this._redirectTo(`/directors/${this.state.savedDirector.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewDirector



// WEBPACK FOOTER //
// ./src/components/Directors/NewDirector.jsx